import { ProjectionCode } from '@models/leaflet';

import geojson from 'geojson';

export interface PlanktonExpedition {
  eventCount: number;
  name: string;
  firstDate: string; // yyyy-mm-dd
  lastDate: string; // yyyy-mm-dd
}

export interface MeasurementOrFact {
  value: string;
  unit?: string;
}

export interface MeasurementsOrFacts {
  expedition: MeasurementOrFact;
  gearType: MeasurementOrFact;
}

export interface PlanktonEventData {
  decimalLatitude: number;
  decimalLongitude: number;
  eventDate: string;
  eventID: string; // UUID
  fieldNumber?: string;
}

export interface PlanktonEvent {
  id: string; // UUID
  originID: string; // UUID
  content: PlanktonEventData;
  measurementsOrFacts?: MeasurementsOrFacts;
  occurrenceCount?: number;
}

export interface PlanktonOccurrenceData {
  eventID: string;
  lifeStage?: string;
  scientificName: string;
  scientificNameID: string;
}

export interface PlanktonOccurrence {
  id: string; // UUID
  originID: string; // UUID
  content: PlanktonOccurrenceData;
  measurementsOrFacts?: MeasurementsOrFacts;
  event?: PlanktonEvent;
  taxon?: PlanktonTaxon;
}

export interface PlanktonOrigin {
  id: string; // UUID
  createdBy: string;
  planktonType: string;
  darwinCoreClass: string;
  sourceType: string;
  metaInfo: Record<string, string | number>;
  isPublished: boolean;
  numberOfItems: number;
}

export interface PlanktonTaxon {
  id: string; // UUID
  class?: string;
  family?: string;
  genus?: string;
  kingdom?: string;
  order?: string;
  phylum?: string;
  scientificName: string;
  scientificNameID?: string;
  occurrenceCount?: number;
}

interface ObjectWithLocationInterface {
  content: {
    decimalLatitude: number;
    decimalLongitude: number;
  };
}

export function createPointGeometry(
  obj: ObjectWithLocationInterface | null,
): geojson.FeatureCollection {
  if (!obj) {
    return {
      type: 'FeatureCollection',
      features: [],
    };
  }
  const lat = obj.content.decimalLatitude;
  const long = obj.content.decimalLongitude;
  const coordinates: geojson.Position = [long, lat];

  let projection = ProjectionCode.Mercator;
  if (lat > 45) {
    projection = ProjectionCode.Arctic;
  } else if (lat < -60) {
    projection = ProjectionCode.Antarctic;
  }

  const feature: geojson.Feature<geojson.Point> = {
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: coordinates,
    },
    properties: {
      projection: projection,
    },
  };

  return {
    type: 'FeatureCollection',
    features: [feature],
  };
}

// see model.PlanktonType in Kinko
export const PlanktonType = [
  'icealgae',
  'microplankton',
  'phytoplankton',
  'protist',
  'sedimenttrap',
  'zooplankton',
];
